module.exports = __webpack_public_path__ + "img/xwzxk3.8f13cf50.png";